let timeout = null;
let timeoutclone = null;
let masterTimeout = null;

export default function initFiches() {
    const fichesEnseignants = document.querySelector('[data-fiches]');

    if (!fichesEnseignants) {
        return;
    }

    function fichesActions() {
        const fichesEnseignantsItems = document.querySelectorAll('[data-fiches]');

        fichesEnseignantsItems.forEach((fichesWrap) => {
            const fiches = fichesWrap.querySelectorAll('[data-fiche]');

            fiches.forEach((item) => {
                if (!item.querySelector('button')) {
                    return;
                }

                item.querySelector('button').addEventListener('click', () => {
                    if (item.classList.contains('is-active')) {
                        return;
                    }

                    if (document.querySelector('.bio-wrapper.clone')) {
                        document.querySelector('.bio-wrapper.clone').remove();
                        document
                            .querySelector('.fiches-item.is-active')
                            .classList.remove('is-active');
                    }

                    const bioHTML = item.querySelector('.bio-wrapper').innerHTML;

                    const newDiv = document.createElement('div');
                    newDiv.classList.add('bio-wrapper', 'clone');
                    newDiv.innerHTML = bioHTML;

                    // Remove clone if exists
                    const clone = document.querySelector('.bio-wrapper.clone');

                    if (clone) {
                        clone.classList.remove('is-active');
                        document
                            .querySelector('[data-fiche].is-active')
                            .classList.remove('is-active');

                        setTimeout(() => {
                            document.querySelectorAll('.bio-wrapper.clone').forEach((clone) => {
                                clone.remove();
                            });
                        }, 300);
                    }

                    // Insert in item parent row
                    item.parentNode.appendChild(newDiv);

                    setTimeout(() => {
                        newDiv.classList.add('is-active');
                        item.classList.add('is-active');

                        // Scroll to element
                        const pos = newDiv.getBoundingClientRect().top + window.scrollY - 155;

                        window.scrollTo({
                            top: pos,
                            behavior: 'smooth',
                        });

                        // close button
                        const closeButton = newDiv.querySelector('.close');

                        closeButton.addEventListener('click', () => {
                            newDiv.classList.remove('is-active');
                            item.classList.remove('is-active');

                            setTimeout(() => {
                                newDiv.remove();
                                document.querySelectorAll('.bio-wrapper.clone').forEach((clone) => {
                                    clone.remove();
                                });
                            }, 300);
                        });
                    }, 100);
                });
            });
        });
    }

    fichesActions();

    const loadMoreBtn = document.querySelector('[data-load-more]');

    if (!loadMoreBtn) {
        return;
    }

    loadMoreBtn.addEventListener('click', () => {
        if (loadMoreBtn.classList.contains('is-loading')) {
            return;
        }

        const loadMoreContainer = loadMoreBtn.getAttribute('data-load-more');
        const loadMoreUrl = loadMoreBtn.getAttribute('data-load-more-url');
        const loadMoreOffset = loadMoreBtn.getAttribute('data-load-more-offset');
        const loadMoreLimit = loadMoreBtn.getAttribute('data-load-more-limit');
        const loadMoreTotal = loadMoreBtn.getAttribute('data-load-more-total');

        loadMoreBtn.classList.add('is-loading');

        fetch(`${loadMoreUrl}?offset=${loadMoreOffset}`)
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newItems = doc.querySelector(loadMoreContainer);

                document.querySelector(loadMoreContainer).innerHTML += newItems.innerHTML;

                loadMoreBtn.classList.remove('is-loading');

                const newOffset = parseInt(loadMoreOffset) + parseInt(loadMoreLimit);

                if (newOffset >= loadMoreTotal) {
                    loadMoreBtn.remove();
                } else {
                    loadMoreBtn.setAttribute('data-load-more-offset', newOffset);
                    loadMoreBtn.classList.remove('is-loading');
                }

                fichesActions();
            });
    });
}
